import React from "react";
import Image from "next/image";
import { useEffect } from "react";
const GlobalLoader = () => {
  useEffect(() => {
    function fadeOutDiv() {
      const loader = document.querySelector(".loader");
      if (loader) {
        loader.style.opacity = "0";
        loader.style.visibility = "hidden";
      }
    }
    setTimeout(fadeOutDiv, 2000);
  }, []);

  return (
    // <div className="loader">
    // 			<div>
    // 				<Image fetchpriority="high" src={'/circleforgif-png.png'} width={20} height={20} alt="" className="w-auto"></Image>
    // 			</div>
    // 		</div>

    <div className="loader flex">
      <div className="m-auto w-[60px] h-auto relative ">
        {/* <Image fetchpriority="high" src={'/circleforgif-png.png'} width={20} height={20} alt="" className="w-auto"></Image> */}
        {/* <Image src={'/images/loader_logo.svg'} width={60} height={60} alt="" /> */}
        <Image
          src={"/images/trans_logo.png"}
          width={70}
          height={70}
          alt=""
          className="w-full h-auto relative z-10"
        />
        <div className="absolute bottom-0 left-0 w-full bg-black z-[9] animateLogoDiv"></div>
      </div>
    </div>
  );
};

export default GlobalLoader;
